// src/pages/UpsellOnlyPaymentPage.js

import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { getUpsellOptions, getOrderDetails } from '../api/vehicleAPI';

import Container from '../components/common/Container';
import OrderSummaryUpsell from '../components/pagamento/OrderSummaryUpsell';
import PaymentFormUpsell from '../components/pagamento/PaymentFormUpsell';
import Loader from '../components/common/Loader';

const PageWrapper = styled.div`
  padding: 120px 0 60px;
`;

const PaymentLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    grid-template-columns: 1fr;
  }
`;

const ErrorMessage = styled.div`
    text-align: center;
    padding: 50px;
    font-size: 18px;
    color: ${({ theme }) => theme.colors.danger};
`;

const UpsellOnlyPaymentPage = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  
  const [upsellOptions, setUpsellOptions] = useState([]);
  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null); // Estado para guardar a mensagem de erro

  useEffect(() => {
    const fetchInitialData = async () => {
      if (!orderId) {
        navigate('/');
        return;
      }
      
      setLoading(true);
      setError(null); // Limpa erros anteriores

      try {
        // --- PASSO 1: BUSCAR DETALHES DO PEDIDO (CLIENTE, PLACA) ---
        const details = await getOrderDetails(orderId);
        if (!details || !details.success) {
          // Se esta chamada falhar, joga um erro específico
          throw new Error(details.message || "Não foi possível carregar os dados do seu pedido.");
        }
        setOrderDetails(details);

        // --- PASSO 2: BUSCAR OPÇÕES DE UPSELL ---
        const options = await getUpsellOptions();
        if (!options || !Array.isArray(options)) {
            // Se esta chamada falhar, joga um erro específico
            throw new Error("Não foi possível carregar as opções de produtos adicionais.");
        }
        setUpsellOptions(options);

      } catch (err) {
        console.error("Erro final ao carregar a página de upsell:", err);
        setError(err.message); // Guarda a mensagem de erro para exibir na tela
      } finally {
        setLoading(false);
      }
    };
    fetchInitialData();
  }, [orderId, navigate]);

  // Se estiver carregando, mostra o Loader
  if (loading) {
    return <Loader />;
  }

  // Se houve um erro, mostra a mensagem de erro em vez da página
  if (error) {
    return <ErrorMessage>Ocorreu um erro: {error}</ErrorMessage>;
  }
  
  // Se tudo deu certo, mostra a página de pagamento
  return (
    <Container>
      <PageWrapper>
        <PaymentLayout>
          <OrderSummaryUpsell upsellOptions={upsellOptions} orderId={orderId} />
          <PaymentFormUpsell orderDetails={orderDetails} />
        </PaymentLayout>
      </PageWrapper>
    </Container>
  );
};

export default UpsellOnlyPaymentPage;